export default __webpack_public_path__ + "static/media/Myriad Pro Light Italic.d4278c5a.otf";